import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import moment from "moment";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
// import Tooltip from "@mui/material/Tooltip";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { getManualSettlement } from "../../redux/actions/getManualSettlementAction";

import { getMerchantWireList } from "../../redux/actions/getMerchantWireListAction";
import { editMerchantWire } from "../../redux/actions/editMerchantWireAction";

import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactToExcel from "react-html-table-to-excel";
import Util from "../../validation/index";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";

import {
	getKycApproveRejects,
	resetGetKycApproveReject
} from "../../redux/actions/getKycApproveRejectAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function ManualSettlement() {
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);

	const [selectedToDate, setSelectedToDate] = useState(new Date());

	const [settleDate, setSettleDate] = useState();

	const [selectedDateVE, setSelectedDateVE] = useState();

	const [selectedToDateVE, setSelectedToDateVE] = useState();

	const navigate = useHistory();

	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);
	const [editOpen, setEditOpen] = React.useState(false);
	const [viewOpen, setViewOpen] = React.useState(false);

	const [getManualSettlementStatus, setGetManualSettlementStatus] =
		useState(false);
	const [getManualSettlementArray, setGetManualSettlementArray] = useState("");

	const [getMerchantWireListStatus, setGetMerchantWireListStatus] =
		useState(false);
	const [getMerchantWireListArray, setGetMerchantWireListArray] = useState("");

	const [getRoleStatus, setGetRoleStatus] = useState(false);
	const [getRoleResArray, setGetRoleResArray] = useState([]);

	const [getKycReportListStatus, setGetKycReportListStatus] = useState(false);
	const [getKycReportListArray, setGetKycReportListArray] = useState([]);

	const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
		useState([]);

	const [getWalletTransactionListArray, setGetWalletTransactionListArray] =
		useState([]);

	const [getWalletTransactionListStatus, setGetWalletTransactionListStatus] =
		useState(false);

	const view = "view";
	const edit = "edit";

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [settleId, setSettleId] = useState("");
	const [processingAmount, setProcessingAmount] = useState("");
	const [chargeAmount, setChargeAmount] = useState("");
	const [netFinalAmount, setNetFinalAmount] = useState("");
	// const [status, setStatus] = useState("")

	const [user, setUser] = useState({
		trackingId: "",
		paymentId: "",
		status: "",
		voucherAmount: "",
		voucherCurrency: "",

		merchantId: "",
		isPaid: ""
		// settleId: "",
		// processingAmount: "",
		// chargeAmount: "",
		// netFinalAmount: "",
		// status: "",
	});

	const {
		trackingId,
		paymentId,
		status,
		voucherAmount,
		voucherCurrency,

		merchantId,
		isPaid
		// settleId,
		// processingAmount,
		// chargeAmount,
		// netFinalAmount,
		// status,
	} = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
	};

	const handleSettleDate = (date) => {
		setSettleDate(date);
	};

	const handleDateChangeVE = (date) => {
		setSelectedDateVE(date);
	};

	const handleToDateChangeVE = (date) => {
		setSelectedToDateVE(date);
	};

	const handleDateChange = (date) => {
		setSelectedDate(date);
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const getManualSettlementRes = useSelector(
		({ getManualSettlement }) => getManualSettlement
	);

	const getMerchantWireListRes = useSelector(
		({ getMerchantWireList }) => getMerchantWireList
	);

	const editMerchantWireRes = useSelector(
		({ editMerchantWire }) => editMerchantWire
	);

	const getRoleListRes = useSelector(({ getRoleList }) => getRoleList);

	const getKycReportListRes = useSelector(
		({ getKycReportList }) => getKycReportList
	);

	const getTransactionTypeListRes = useSelector(
		({ getTransactionTypeList }) => getTransactionTypeList
	);

	const getWalletTransactionListRes = useSelector(
		({ getWalletTransactionList }) => getWalletTransactionList
	);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const getManualSettlementReq = () => {
		setGetManualSettlementStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				fdtstamp: moment(selectedDate).format("YYYY/MM/DD"),
				tdtstamp: moment(selectedToDate).format("YYYY/MM/DD"),
				trackingId: trackingId,
				paymentId: paymentId,
				status: status,
				voucherAmount: voucherAmount,
				voucherCurrency: voucherCurrency
			}
		};

		dispatch(getManualSettlement(req, authToken));
	};

	const getManualSettlementFunc = () => {
		if (getManualSettlementStatus) {
			if (getManualSettlementRes.data.status == "success") {
				setPage(0);
				setGetManualSettlementArray([].concat(getManualSettlementRes.data.manualList));
			}
			if (getManualSettlementRes.data.status == "failed") {
				setGetManualSettlementArray(getManualSettlementRes.data);
				if (
					getManualSettlementRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getManualSettlementRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getManualSettlementFunc();
	}, [getManualSettlementRes.data.status]);

	const getMerchantWireListReq = () => {
		setGetMerchantWireListStatus(true);
		setIsLoading(true);
		const req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				fdtstamp: moment(selectedDate).format("DD/MM/YYYY"),
				tdtstamp: moment(selectedToDate).format("DD/MM/YYYY"),
				status: isPaid,
				toId: merchantId
			}
		};
		dispatch(getMerchantWireList(req, authToken));
	};

	const getMerchantWireListFunc = () => {
		if (getMerchantWireListStatus) {
			if (getMerchantWireListRes.data.status == "success") {
				setGetMerchantWireListArray(
					[].concat(getMerchantWireListRes.data.reportList)
				);
			}
			if (getMerchantWireListRes.data.status == "failed") {
				setGetMerchantWireListArray(getMerchantWireListRes.data);
				if (
					getMerchantWireListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getMerchantWireListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			setIsLoading(false);
		}
	};

	useEffect(() => {
		getMerchantWireListFunc();
	}, [getMerchantWireListRes.data.status]);

	const setData = (row, fs) => {
		setSettleId(row.settleId);
		setSettleDate(row.settleDate);
		setSelectedDateVE(row.firstDate);
		setSelectedToDateVE(row.lastDate);
		setProcessingAmount(row.processingAmount);
		setChargeAmount(row.chargeAmount);
		setNetFinalAmount(row.netFinalAmount);
		// setStatus(row.status)
		if (fs == "view") {
			setViewOpen(true);
		}
		if (fs == "edit") {
			setEditOpen(true);
		}
	};

	const editMerchantWireReq = () => {
		let req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				settledDate: settleDate || "",
				status: status,
				settledId: settleId
			}
		};
		dispatch(editMerchantWire(req, authToken));
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	// const handleChangeRowsPerPage = (event) => {
	// 	setRowsPerPage(parseInt(event.target.value, 10));
	// 	setPage(0);
	// };
	const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        const currentFirstRowIndex = page * rowsPerPage;
        const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);
   
        setRowsPerPage(newRowsPerPage);
        setPage(newPage);
    };

	const handleClose = () => {
		setEditOpen(false);
		setViewOpen(false);
	};

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							gap: "10px",
							textAlign: "center"
						}}
					>
						<Grid item xs={12} md={8} sm={3} lg={8}></Grid>
						<Grid item xs={12} md={4} sm={3} lg={3}>
							{/* <Button
                                variant="contained"
                                style={{ backgroundColor: "#00b9f5", color: "white" }}
                                size="small"
                            // onClick={() => addCurrency()}
                            >
                                Upload Settlement Report
                            </Button> */}
							{/* <CustomButton
								style={{
									padding: "8px"
								}}
							>
								Upload Settlement Report
							</CustomButton> */}
						</Grid>
					</Grid>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="From Date"
										format="MM/dd/yyyy"
										value={selectedDate}
										onChange={handleDateChange}
								variant="standard"

									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="To Date"
										format="MM/dd/yyyy"
										value={selectedToDate}
										onChange={handleToDateChange}
								variant="standard"

									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="Tracking Id"
								fullWidth={true}
								name="trackingId"
								value={trackingId}
								variant="standard"
								// onChange={onInputChange}
								style={{ marginTop: "3px" }}

								onChange={(e) => onInputChange(e, "number")}
								sx={{
									"& .MuiInput-underline:before": {
									  borderBottomColor: "gray", // White color for the underline before focus
									},
									"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
									  borderBottomColor: "gray", // White color on hover
									},
									"& .MuiInput-underline:after": {
									  borderBottomColor: "gray", // White color after focus
									},
								  }}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="Payment Id"
								fullWidth={true}
								name="paymentId"
								variant="standard"
								style={{ marginTop: "3px" }}

								value={paymentId}
								// onChange={onInputChange}
								onChange={(e) => onInputChange(e, "number")}
								sx={{
									"& .MuiInput-underline:before": {
									  borderBottomColor: "gray", // White color for the underline before focus
									},
									"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
									  borderBottomColor: "gray", // White color on hover
									},
									"& .MuiInput-underline:after": {
									  borderBottomColor: "gray", // White color after focus
									},
								  }}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								style={{ marginTop: "0rem" }}
								select
								margin="dense"
								id="name"
								label="Status"
								variant="standard"

								type="name"
								fullWidth
								name="status"
								// value={verificationStatus || ""}
								defaultValue={"All" || status}
								onChange={(e) => onInputChange(e)}
								sx={{
									"& .MuiInput-underline:before": {
									  borderBottomColor: "gray", // White color for the underline before focus
									},
									"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
									  borderBottomColor: "gray", // White color on hover
									},
									"& .MuiInput-underline:after": {
									  borderBottomColor: "gray", // White color after focus
									},
								  }}
							>
								<MenuItem value="All" selected="All">
									All
								</MenuItem>
								<MenuItem value="Purchase Successfull">
									Purchase Successfull
								</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="Voucher Amount"
								fullWidth={true}
								variant="standard"

								name="voucherAmount"
								value={voucherAmount}
								// onChange={onInputChange}
								onChange={(e) => onInputChange(e, "number")}
								sx={{
									"& .MuiInput-underline:before": {
									  borderBottomColor: "gray", // White color for the underline before focus
									},
									"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
									  borderBottomColor: "gray", // White color on hover
									},
									"& .MuiInput-underline:after": {
									  borderBottomColor: "gray", // White color after focus
									},
								  }}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="Voucher Currency"
								fullWidth={true}
								variant="standard"

								name="voucherCurrency"
								value={voucherCurrency}
								// onChange={onInputChange}
								onChange={(e) => onInputChange(e, "alphabet")}
								sx={{
									"& .MuiInput-underline:before": {
									  borderBottomColor: "gray", // White color for the underline before focus
									},
									"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
									  borderBottomColor: "gray", // White color on hover
									},
									"& .MuiInput-underline:after": {
									  borderBottomColor: "gray", // White color after focus
									},
								  }}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getManualSettlementReq}
							>
								Search
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getManualSettlementReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getManualSettlementArray.length == undefined ||
					!getManualSettlementStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Summary Data
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<div>
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Report Table
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3">
									<Table className={classes.table}>
										<TableHead>
											<TableRow className="tableHeaderColor">
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Partner ID{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													status
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Time Stamp
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Tracking Id
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Voucher Amount
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Voucher Currency
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													dtstamp
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{getManualSettlementArray &&
												[]
													.concat(getManualSettlementArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell align="center">
																{row.partnerId}
															</TableCell>
															<TableCell align="center">{row.status}</TableCell>
															<TableCell align="center">
																{row.timeStamp}
															</TableCell>
															<TableCell align="center">
																{row.trackingId}
															</TableCell>

															<TableCell align="center">
																{row.voucherAmount}
															</TableCell>
															<TableCell align="center">
																{row.voucherCurrency}
															</TableCell>

															<TableCell align="center">
																{row.dtstamp}
															</TableCell>

															{/* <TableCell align="center">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px",
                                                                    }}
                                                                    onClick={() => setData(row, "view")}
                                                                >
                                                                    {
                                                                        <VisibilityIcon
                                                                            style={{
                                                                                color: "#fff",
                                                                                fontSize: "20px"
                                                                            }}
                                                                        />
                                                                    }
                                                                </CustomButton>
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px",
                                                                    }}
                                                                    onClick={() => setData(row, "edit")}
                                                                >
                                                                    {
                                                                        <EditIcon
                                                                            style={{
                                                                                color: "#fff",
                                                                                fontSize: "20px"
                                                                            }}
                                                                        />
                                                                    }
                                                                </CustomButton>
                                                            </TableCell> */}
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={[].concat(getManualSettlementArray).length}
										rowsPerPage={rowsPerPage}
										page={page}
										onPageChange={handleChangePage}
										onRowsPerPageChange={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					</div>
				)}
			</Layout>
			{/* <div>
                <Dialog open={editOpen} onClose={handleClose}>
                    <DialogTitle>Edit Integration</DialogTitle>
                    <DialogContent>

                        <TextField
                            required
                            disabled
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Settled ID"
                            fullWidth={true}
                            name="settleId"
                            value={settleId || ""}
                        ></TextField>

                        <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Settled Date"
                            fullWidth={true}
                            name="settleDate"
                            value={settleDate || ""}
                        ></TextField>

                        <TextField
                            required
                            disabled
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Start Date"
                            fullWidth={true}
                            name="selectedDateVE"
                            value={selectedDateVE || ""}
                        ></TextField>

                        <TextField
                            required
                            disabled
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="End Date"
                            fullWidth={true}
                            name="selectedToDateVE"
                            value={selectedToDateVE || ""}
                        ></TextField>

                        <TextField
                            required
                            disabled
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Processing Amount"
                            fullWidth={true}
                            name="processingAmount"
                            value={processingAmount || ""}
                        ></TextField>

                        <TextField
                            required
                            disabled
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Charge Amount"
                            fullWidth={true}
                            name="chargeAmount"
                            value={chargeAmount || ""}
                        ></TextField>

                        <TextField
                            required
                            disabled
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Net Final Amount"
                            fullWidth={true}
                            name="netFinalAmount"
                            value={netFinalAmount || ""}
                        ></TextField>

                        <TextField
                            required
                            select
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Status"
                            fullWidth={true}
                            name="status"
                            defaultValue={status || ""}
                        >
                            <MenuItem
                                value="paid"
                            >
                                Paid
                            </MenuItem>
                            <MenuItem
                                value="unpaid"
                            >
                                Unpaid
                            </MenuItem>
                        </TextField>
                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <Button
                            style={{
                                backgroundColor: "#fff",
                                color: "#000"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{
                                backgroundColor: "#00b9f5",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={editMerchantWireReq}
                        >
                            Edit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>

            <div>
                <Dialog open={viewOpen} onClose={handleClose}>
                    <DialogTitle>View Merchant Wire Report</DialogTitle>
                    <DialogContent>

                        <TextField
                            disabled
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Settled ID"
                            fullWidth={true}
                            name="settleId"
                            value={settleId || ""}
                        ></TextField>

                        <TextField
                            disabled
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Settled Date"
                            fullWidth={true}
                            name="settleDate"
                            value={settleDate || ""}
                        ></TextField>

                        <TextField
                            disabled
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Start Date"
                            fullWidth={true}
                            name="selectedDateVE"
                            value={selectedDateVE || ""}
                        ></TextField>

                        <TextField
                            disabled
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="End Date"
                            fullWidth={true}
                            name="selectedToDateVE"
                            value={selectedToDateVE || ""}
                        ></TextField>

                        <TextField
                            disabled
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Processing Amount"
                            fullWidth={true}
                            name="processingAmount"
                            value={processingAmount || ""}
                        ></TextField>

                        <TextField
                            disabled
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Charge Amount"
                            fullWidth={true}
                            name="chargeAmount"
                            value={chargeAmount || ""}
                        ></TextField>

                        <TextField
                            disabled
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Net Final Amount"
                            fullWidth={true}
                            name="netFinalAmount"
                            value={netFinalAmount || ""}
                        ></TextField>

                        <TextField
                            disabled
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="text"
                            label="Status"
                            fullWidth={true}
                            name="status"
                            defaultValue={status || ""}
                        >
                        </TextField>
                    </DialogContent>
                    <DialogActions style={{ padding: "14px" }}>
                        <Button
                            style={{
                                backgroundColor: "#00b9f5",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div> */}
		</>
	);
}

export default ManualSettlement;
